"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formStateResolvers = void 0;

var _immutable = require("immutable");

var _fieldReducer = require("./reducer/fieldReducer");

var formStateResolvers = function formStateResolvers(state) {
  var getAnyTouched = function getAnyTouched() {
    return state.get(_fieldReducer.fieldsKey, (0, _immutable.Map)()).reduce(function (bool, v) {
      return bool || v.getIn(['current', 'touched']);
    }, false);
  };

  var getIsPristine = function getIsPristine() {
    return state.get(_fieldReducer.fieldsKey, (0, _immutable.Map)()).reduce(function (bool, v) {
      return bool && v.getIn(['current', 'pristine']);
    }, true);
  };

  return {
    getAnyTouched: getAnyTouched,
    getIsPristine: getIsPristine
  };
};

exports.formStateResolvers = formStateResolvers;